module.exports = __webpack_public_path__ + "img/progress_012.4887f8f2.png";